module.exports = __webpack_public_path__ + "fd64c0ae.png";